/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import classes from './TabMenu.scss';

interface ITabMenuItem {
  title: string;
  onClick: () => void;
}

interface ITabMenu {
  menuItems: ITabMenuItem[];
  selectedIndex?: number;
}

const TabMenu: React.FC<ITabMenu> = ({ menuItems, selectedIndex = 0 }) => {
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(selectedIndex);

  // RTL'de sekmeler sağdan sola sıralanır; underline'ı hem index kaydırması hem de
  // yarım-rem ortalama ofseti bakımından ters yönde hareket ettirmeliyiz.
  const isRtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
  const directionSign = isRtl ? -1 : 1;

  return (
    <div className={classes.tabMenuWrapper}>
      <div className={classes.tabMenu}>
        {menuItems.map((menuItem, index) => (
          <div
            key={`tab_menu_item_${index}`}
            role="button"
            tabIndex={0}
            className={classes.tabMenuItem}
            onClick={() => {
              setSelectedMenuIndex(index);
              menuItem.onClick();
            }}
            onKeyDown={() => {}}
          >
            <div className={classes.tabMenuItemText}>{menuItem.title}</div>
          </div>
        ))}
        <div className={classes.underlineContainer}>
          <div
            className={classes.underline}
            style={{
              width: `calc(100% / ${menuItems.length} + 1rem)`,
              transform: `translateX(${selectedMenuIndex * 100 * directionSign}%) translateX(${-0.5 * directionSign}rem)`,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TabMenu;
